import '../../components/Category/Card/CategoryCard.css';
import './VodaPayClubPage.css';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import VodaPayClubTicket from '../../assets/VodaPayClubTicket.jsx';
import ChevronRightIcon from '../../assets/ChevronRight.jsx';
import CategoryVendors from '../../components/Category/Vendors/CategoryVendors.jsx';
import CategoryVouchers from '../../components/Category/Vouchers/CategoryVouchers.jsx';
import { CategoriesContext } from '../../services/context/CategoriesContext.js';
import { defaultAnalyticsVariables, events, pagePrefix } from '../../services/Constants/Analytics.js';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';

/**
 * @returns {JSX.Element} VodaPayClubPage component
 */
export default function VodaPayClubPage() {
  const analyticsName = `${pagePrefix}: manage subscription`;
  const navigateTo = useNavigate();
  const categories = useContext(CategoriesContext);
  const category = categories?.find(element => element.isClubCategory === true);
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const subscriptionStatus = useNormalizedSubscriptionStatus();
  const { isSubscribed, planExpiryDate, isEligibleToSubscribe, subscribedPlan } = subscriptionDetails;
  // Set flag for "active but cancelled
  const { isAutoRenewal } = subscribedPlan || {};
  const isSubscriptionCancelled = isSubscribed === true && isAutoRenewal === false && isEligibleToSubscribe === false;
  const subscriptionsExpirationDate = moment.utc(planExpiryDate).format('DD-MM-YYYY');

  useEffect(() => {
    window.utag?.view({
      ...defaultAnalyticsVariables,
      event_name: [events.pageView],
      page_name: analyticsName,
      link_id: `${pagePrefix}: cancel subscription`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  }, []);

  const onClickAnalytics = () => {
    window.utag?.link({
      ...defaultAnalyticsVariables,
      event_name: [events.interaction],
      page_name: analyticsName,
      link_id: `${pagePrefix}: cancel subscription`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  };

  return (
    <div className='top-container'>
      <div className='image-container'>
        <VodaPayClubTicket />
      </div>
      <h2 className='title'>Your VodaPay Club Membership</h2>
      {
        isSubscriptionCancelled ? <span className='validity'>Membership valid until: {subscriptionsExpirationDate}</span>
          : <>
            <h3 className='sub-title'> Your subscription is active until {subscriptionsExpirationDate}.</h3>
            <button
              className='manage-button-style'
              onClick={
                () => {
                  navigateTo(ROUTES.ARE_YOU_SURE);
                  onClickAnalytics();
                }
              }
            >Cancel membership <ChevronRightIcon />
            </button>
          </>
      }
      <CategoryVendors category={ category } />
      <CategoryVouchers category={ category } />
    </div>
  );
}
